/* Atrask priedus – sections/accessory-finder.liquid */
(function () {
  'use strict';
  var SELECTOR = '[data-accessory-finder]';
  var cache = new Map();

  function plural(n) {
    var d = n % 10, h = n % 100;
    if (d === 1 && h !== 11) return 'priedas';
    if (d >= 2 && d <= 9 && (h < 11 || h > 19)) return 'priedai';
    return 'priedų';
  }

  function fetchResults(url) {
    if (cache.has(url)) return cache.get(url);
    var request = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-af-results]');
        if (!node) throw new Error('No results node');
        var vendorsNode = node.querySelector('[data-af-vendors]');
        var vendors = {};
        try { vendors = JSON.parse(vendorsNode ? vendorsNode.textContent : '{}'); } catch (e) {}
        var items = node.querySelector('[data-af-items]');
        return {
          count: parseInt(node.getAttribute('data-count'), 10) || 0,
          vendors: vendors,
          html: items ? items.innerHTML.trim() : '',
          shown: items ? items.children.length : 0
        };
      });
    request.catch(function () { cache.delete(url); });
    cache.set(url, request);
    return request;
  }

  // „Kepimo paviršiai“ -> „kepimo-pavirsiai“, „Kamado Joe“ -> „kamado-joe“
  function toHandle(str) {
    var map = { 'ą': 'a', 'č': 'c', 'ę': 'e', 'ė': 'e', 'į': 'i', 'š': 's', 'ų': 'u', 'ū': 'u', 'ž': 'z' };
    return String(str || '').toLowerCase()
      .replace(/[ąčęėįšųūž]/g, function (c) { return map[c]; })
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Nuorodos į bloką: #atrask-priedus arba #af-<kategorija | gamintojas>, pvz. #af-enders, #af-rukymas
  function parseHash(hash) {
    var m = /^#(?:atrask-priedus|af-([a-z0-9-]+))$/i.exec(hash || '');
    return m ? (m[1] || '').toLowerCase() : null;
  }

  function track(data) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(Object.assign({ event: 'accessory_finder' }, data));
    }
  }

  function AccessoryFinder(el) {
    this.el = el;
    this.section = el.getAttribute('data-results-section');
    this.cats = Array.prototype.slice.call(el.querySelectorAll('[data-af-cat]'));
    this.brands = Array.prototype.slice.call(el.querySelectorAll('[data-af-brand]'));
    this.heroes = Array.prototype.slice.call(el.querySelectorAll('[data-af-hero]'));
    this.trackEl = el.querySelector('[data-af-track]');
    this.statusEl = el.querySelector('[data-af-status]');
    this.viewAll = el.querySelector('[data-af-view-all]');
    this.prev = el.querySelector('[data-af-prev]');
    this.next = el.querySelector('[data-af-next]');
    this.brandsWrap = el.querySelector('[data-af-brands]');
    this.vendorMap = {};
    this.token = 0;
    this.started = false;
    if (!this.cats.length || !this.trackEl) return;

    var active = this.cats.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || this.cats[0];
    this.cat = active.getAttribute('data-af-cat');
    this.vendor = '';

    this.onClick = this.onClick.bind(this);
    this.onHover = this.onHover.bind(this);
    this.updateNav = this.updateNav.bind(this);
    el.addEventListener('click', this.onClick);
    el.addEventListener('pointerover', this.onHover);
    el.addEventListener('focusin', this.onHover);
    el.addEventListener('touchstart', this.onHover, { passive: true });
    this.trackEl.addEventListener('scroll', this.updateNav, { passive: true });
    window.addEventListener('resize', this.updateNav, { passive: true });

    // Hero nuotraukos atsiranda sklandžiai, kai įsikelia
    this.heroes.forEach(function (h) {
      var img = h.querySelector('.af-hero__img');
      if (!img) return;
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth) done(); else img.addEventListener('load', done, { once: true });
    });
    el.classList.add('is-ready');

    var self = this;
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          self.io.disconnect();
          self.start();
        }
      }, { rootMargin: '600px 0px' });
      this.io.observe(el);
    } else {
      this.start();
    }
  }

  AccessoryFinder.prototype.start = function () {
    if (this.started) return;
    this.started = true;
    this.load();
  };

  AccessoryFinder.prototype.catEl = function (id) {
    return this.cats.filter(function (c) { return c.getAttribute('data-af-cat') === id; })[0];
  };

  AccessoryFinder.prototype.url = function (catId, vendor, forSection) {
    var c = this.catEl(catId);
    var params = new URLSearchParams(c.getAttribute('data-query') || '');
    if (vendor) {
      var info = (this.vendorMap[catId] || {})[vendor.toLowerCase()];
      params.append('filter.p.vendor', info ? info.v : vendor);
    }
    if (this.el.getAttribute('data-in-stock') === 'true') params.set('filter.v.availability', '1');
    params.set('sort_by', this.el.getAttribute('data-sort') || 'best-selling');
    if (forSection) params.set('section_id', this.section);
    return c.getAttribute('data-base') + '?' + params.toString();
  };

  // Pradeda krauti kategorijos hero nuotrauką, kai lankytojas ketina ją pasirinkti
  AccessoryFinder.prototype.warmHero = function (id) {
    var hero = this.heroes.filter(function (h) { return h.getAttribute('data-af-hero') === id; })[0];
    var img = hero && hero.querySelector('.af-hero__img');
    if (img && img.loading === 'lazy') img.loading = 'eager';
  };

  AccessoryFinder.prototype.onHover = function (e) {
    var cat = e.target.closest && e.target.closest('[data-af-cat]');
    if (cat) this.warmHero(cat.getAttribute('data-af-cat'));
    if (!this.started) return;
    if (cat) { fetchResults(this.url(cat.getAttribute('data-af-cat'), '', true)); return; }
    var brand = e.target.closest && e.target.closest('[data-af-brand]');
    if (brand && brand.getAttribute('data-af-brand') && this.vendorMap[this.cat]) {
      fetchResults(this.url(this.cat, brand.getAttribute('data-af-brand'), true));
    }
  };

  AccessoryFinder.prototype.onClick = function (e) {
    var cat = e.target.closest('[data-af-cat]');
    if (cat) { this.selectCat(cat.getAttribute('data-af-cat')); return; }
    var brand = e.target.closest('[data-af-brand]');
    if (brand) { this.selectVendor(brand.getAttribute('data-af-brand')); return; }
    var add = e.target.closest('[data-af-add]');
    if (add) { e.preventDefault(); this.addToCart(add); return; }
    if (e.target.closest('[data-af-prev]')) { this.scrollBy(-1); return; }
    if (e.target.closest('[data-af-next]')) { this.scrollBy(1); return; }
    if (e.target.closest('[data-af-reset]')) { this.selectVendor(''); }
  };

  AccessoryFinder.prototype.setCat = function (id) {
    this.warmHero(id);
    this.cat = id;
    this.vendor = '';
    this.cats.forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-af-cat') === id)); });
    this.heroes.forEach(function (h) {
      var on = h.getAttribute('data-af-hero') === id;
      h.hidden = !on;
      h.classList.toggle('is-active', on);
    });
    this.setBrandPressed('');
  };

  AccessoryFinder.prototype.selectCat = function (id, silent) {
    if (!this.catEl(id)) return;
    var changed = id !== this.cat;
    this.setCat(id);
    if (changed && !silent) track({ af_action: 'category', af_category: this.catEl(id).getAttribute('data-title') });
    this.started = true;
    this.load();
  };

  // Atidaro kategoriją / gamintoją pagal nuorodą ir sklandžiai nuslenka iki bloko.
  // Kai nurodytas tik gamintojas, rodoma pirmoji kategorija (Geriausi pasiūlymai).
  AccessoryFinder.prototype.goTo = function (token) {
    var catId = null;
    var vendor = '';
    if (token) {
      var cat = this.cats.filter(function (c) { return toHandle(c.getAttribute('data-title')) === token; })[0];
      if (cat) {
        catId = cat.getAttribute('data-af-cat');
      } else {
        var brand = this.brands.filter(function (b) {
          var v = b.getAttribute('data-af-brand');
          return v && toHandle(v) === token;
        })[0];
        if (brand) vendor = brand.getAttribute('data-af-brand');
      }
    }
    this.setCat(catId || this.cats[0].getAttribute('data-af-cat'));
    this.vendor = vendor;
    this.setBrandPressed(vendor);
    if (this.io) this.io.disconnect();
    this.started = true;
    this.load();
    this.scrollIntoView();
    track({ af_action: 'link', af_category: this.catEl(this.cat).getAttribute('data-title'), af_brand: vendor || 'visi' });
  };

  AccessoryFinder.prototype.scrollIntoView = function () {
    var header = document.querySelector('.header__outer-wrapper');
    var offset = 0;
    if (header) {
      var position = getComputedStyle(header).position;
      if (position === 'sticky' || position === 'fixed') offset = header.offsetHeight;
    }
    var target = this.el.querySelector('.section-header') || this.el;
    var top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - offset - 16);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });

    // Atsarginis variantas: jei sklandų slinkimą kas nors nutraukė, nušokame iškart
    // (nebent lankytojas pats pradėjo slinkti)
    var userScrolled = false;
    var markUser = function () { userScrolled = true; };
    window.addEventListener('wheel', markUser, { passive: true, once: true });
    window.addEventListener('touchstart', markUser, { passive: true, once: true });
    setTimeout(function () {
      window.removeEventListener('wheel', markUser);
      window.removeEventListener('touchstart', markUser);
      if (!userScrolled && Math.abs(window.pageYOffset - top) > 40) window.scrollTo(0, top);
    }, 1000);
  };

  AccessoryFinder.prototype.selectVendor = function (vendor) {
    if (vendor === this.vendor) return;
    this.vendor = vendor;
    this.setBrandPressed(vendor);
    track({ af_action: 'brand', af_category: this.catEl(this.cat).getAttribute('data-title'), af_brand: vendor || 'visi' });
    this.load();
  };

  AccessoryFinder.prototype.setBrandPressed = function (vendor) {
    this.brands.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-af-brand') === vendor)); });
  };

  // Rodo tik tuos gamintojus, kurie turi prekių pasirinktai kategorijai, ir jų kiekius
  AccessoryFinder.prototype.updateBrands = function (catId, all) {
    // all.vendors: { "napoleon": { v: "NAPOLEON", c: 14 } } – v yra tiksli reikšmė filtrui
    this.vendorMap[catId] = all.vendors;
    var visible = 0;
    this.brands.forEach(function (b) {
      var vendor = b.getAttribute('data-af-brand');
      var countEl = b.querySelector('[data-af-count]');
      if (!vendor) { if (countEl) countEl.textContent = all.count; return; }
      var info = all.vendors[vendor.toLowerCase()];
      var count = info ? info.c : 0;
      b.hidden = count === 0;
      if (count) visible++;
      if (countEl) countEl.textContent = count || '';
    });
    if (this.brandsWrap) this.brandsWrap.toggleAttribute('data-none', visible === 0);
  };

  AccessoryFinder.prototype.load = function () {
    var self = this;
    var token = ++this.token;
    var catId = this.cat;
    var allUrl = this.url(catId, '', true);
    if (!cache.has(allUrl)) this.skeleton();
    this.el.classList.add('is-loading');
    this.trackEl.setAttribute('aria-busy', 'true');

    fetchResults(allUrl)
      .then(function (all) {
        if (token !== self.token) return null;
        self.updateBrands(catId, all);

        if (self.vendor && !all.vendors[self.vendor.toLowerCase()]) {
          self.vendor = '';
          self.setBrandPressed('');
        }
        if (!self.vendor) return { data: all, url: self.url(catId, '', false) };
        return fetchResults(self.url(catId, self.vendor, true)).then(function (data) {
          return { data: data, url: self.url(catId, self.vendor, false) };
        });
      })
      .then(function (result) {
        if (!result || token !== self.token) return;
        self.render(result.data, result.url);
      })
      .catch(function () {
        if (token !== self.token) return;
        self.renderError();
      })
      .then(function () {
        if (token !== self.token) return;
        self.el.classList.remove('is-loading');
        self.trackEl.setAttribute('aria-busy', 'false');
      });
  };

  AccessoryFinder.prototype.skeleton = function () {
    var one = '<div class="af-card af-card--skeleton" aria-hidden="true"><div class="af-card__media"></div><div class="af-card__meta"><span></span><span></span><span></span></div></div>';
    this.trackEl.classList.remove('is-empty');
    this.trackEl.innerHTML = new Array(6).join(one);
  };

  AccessoryFinder.prototype.render = function (data, viewAllUrl) {
    var label = this.el.getAttribute('data-view-all') || 'Peržiūrėti visus';
    if (this.viewAll) {
      this.viewAll.href = viewAllUrl;
      this.viewAll.setAttribute('data-short', 'Visi (' + data.count + ')');
      var t = this.viewAll.querySelector('[data-af-view-all-text]');
      if (t) t.textContent = label + ' (' + data.count + ')';
      this.viewAll.hidden = data.count === 0;
    }
    if (!data.count) {
      this.trackEl.classList.add('is-empty');
      this.trackEl.innerHTML = '<div class="af__empty-state"><span>Šiam deriniui priedų šiuo metu neturime.</span>' +
        (this.vendor ? '<button type="button" data-af-reset>Rodyti visų gamintojų</button>' : '') + '</div>';
    } else {
      this.trackEl.classList.remove('is-empty');
      var more = '';
      if (data.count > data.shown) {
        more = '<a class="af-card af-card--more" href="' + viewAllUrl + '"><strong>' + label + '</strong><span>' +
          data.count + ' ' + plural(data.count) + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      }
      this.trackEl.innerHTML = data.html + more;
    }
    this.trackEl.scrollLeft = 0;
    if (this.statusEl) {
      var cat = this.catEl(this.cat).getAttribute('data-title');
      this.statusEl.textContent = cat + (this.vendor ? ', ' + this.vendor : '') + ': ' + data.count + ' ' + plural(data.count);
    }
    var self = this;
    requestAnimationFrame(function () { self.updateNav(); });
  };

  AccessoryFinder.prototype.renderError = function () {
    this.trackEl.classList.add('is-empty');
    this.trackEl.innerHTML = '<div class="af__empty-state"><span>Nepavyko įkelti priedų.</span><button type="button" data-af-retry>Bandyti dar kartą</button></div>';
    var self = this;
    var retry = this.trackEl.querySelector('[data-af-retry]');
    if (retry) retry.addEventListener('click', function () { self.load(); });
  };

  AccessoryFinder.prototype.scrollBy = function (dir) {
    this.trackEl.scrollBy({ left: dir * this.trackEl.clientWidth * 0.9, behavior: 'smooth' });
  };

  AccessoryFinder.prototype.updateNav = function () {
    if (!this.prev || !this.next) return;
    var t = this.trackEl;
    var scrollable = t.scrollWidth > t.clientWidth + 4;
    this.prev.hidden = !scrollable;
    this.next.hidden = !scrollable;
    this.prev.classList.toggle('is-off', t.scrollLeft < 4);
    this.next.classList.toggle('is-off', t.scrollLeft + t.clientWidth >= t.scrollWidth - 4);
  };

  AccessoryFinder.prototype.addToCart = function (btn) {
    if (btn.getAttribute('data-state') === 'loading') return;
    var card = btn.closest('[data-af-card]');
    var msg = card && card.querySelector('[data-af-msg]');
    if (msg) msg.textContent = '';
    btn.setAttribute('data-state', 'loading');
    var routes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
    fetch((routes.add || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.setAttribute('data-state', 'added');
        // Cornerstone tema: atnaujina krepšelio skaitiklį ir atidaro greitąjį krepšelį
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        track({ af_action: 'add_to_cart', af_variant: btn.getAttribute('data-variant-id') });
        setTimeout(function () { btn.removeAttribute('data-state'); }, 1800);
      })
      .catch(function (err) {
        btn.setAttribute('data-state', 'error');
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Nepavyko įdėti į krepšelį';
        setTimeout(function () { btn.removeAttribute('data-state'); }, 2500);
      });
  };

  AccessoryFinder.prototype.destroy = function () {
    if (this.io) this.io.disconnect();
    window.removeEventListener('resize', this.updateNav);
  };

  var instances = new Map();
  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(SELECTOR), function (el) {
      if (instances.has(el)) return;
      instances.set(el, new AccessoryFinder(el));
    });
  }

  function firstInstance() {
    var el = document.querySelector(SELECTOR);
    return el ? instances.get(el) : null;
  }

  init(document);

  if (!window.__accessoryFinderEditor) {
    window.__accessoryFinderEditor = true;

    // Paspaudus nuorodą į tą patį puslapį (pvz. hero banerio „/#af-napoleon“) – be perkrovimo
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      var token = parseHash(url.hash);
      var inst = firstInstance();
      if (token === null || !inst || url.pathname !== window.location.pathname) return;
      e.preventDefault();
      // Temos puslapių perėjimo efektas gaudo visas nuorodas – sustabdome, kad neliktu balto ekrano
      e.stopPropagation();
      inst.goTo(token);
    }, true);

    // Atėjus iš kito puslapio, naujienlaiškio ar reklamos su griliai.lt/#af-...
    var initialToken = parseHash(window.location.hash);
    if (initialToken !== null) {
      var openInitial = function () {
        var inst = firstInstance();
        if (inst) inst.goTo(initialToken);
      };
      if (document.readyState === 'complete') openInitial(); else window.addEventListener('load', openInitial);
    }
    window.addEventListener('hashchange', function () {
      var token = parseHash(window.location.hash);
      var inst = firstInstance();
      if (token !== null && inst) inst.goTo(token);
    });

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector(SELECTOR);
      if (el && instances.has(el)) { instances.get(el).destroy(); instances.delete(el); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target.closest(SELECTOR);
      var inst = el && instances.get(el);
      if (!inst) return;
      var catId = e.target.getAttribute('data-af-cat');
      if (catId) inst.selectCat(catId, true);
    });
  }
})();
